import axios from "axios";

/* https://api.frankfurter.app/latest?from=sgd&to=inr&amount=100 */

export const state = () => ({ currency: "", loading: false });

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Jan 2025 | 10:50AM
   * @param {*} state
   * @param {*} value
   */
  set_currency(state, value) {
    state.currency = value;
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 31 Jan 2025 | 03:56PM
   * @param {*} state
   * @param {*} value
   */
  set_loading(state, value) {
    state.loading = value;
  }
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Jan 2025 | 10:56AM
   * @param {*} { commit }
   * @param {*} payload
   * @returns {*}
   */
  fetchCurrency({ commit }, payload) {
    return new Promise(async (resolve) => {
      commit("set_loading", true);
      if (payload.from != payload.to) {
        const _result = await axios.get(`https://api.frankfurter.app/latest?from=${payload.from}&to=${payload.to}`).then(({ data }) => data);
        commit("set_loading", false);
        if (_result.rates[payload?.to?.toUpperCase()]) commit("set_currency", _result.rates[payload?.to?.toUpperCase()]);
        else commit("set_currency", "");
      } else commit("set_currency", "");
      commit("set_loading", false);
    });
  }
};

export const getters = {
  currency: (state) => state.currency,
  loading: (state) => state.loading
};
